import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MarianomGeneral } from '../marianom-general.service';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';

@Component({
  selector: 'foo-mariano-max',
  templateUrl: './foo-mariano-max.component.html',
  styleUrls: ['./foo-mariano-max.component.scss']
})

export class FooMarianoMaxComponent implements OnInit {
  @Input('mode') modo: string = 'normal';;

  terminos_condiciones: string;
  informacion_envio: string;
  politica_devoluciones: string;
  data_Empresa: string;
  work_With_As: string;
  info_Prov: string;
  botonNovedades: string;
  private today: Date = new Date();
  year: number;

  constructor(private genServ: EcommerceGenericoService, private modal: ModalService, private cdr: ChangeDetectorRef) {
    this.year = this.today.getFullYear();
  }

  ngOnInit(): void {
    this.terminos_condiciones = this.genServ.getTerminosCondiciones();
    this.informacion_envio = this.genServ.getInformacionEnvio();
    this.politica_devoluciones = this.genServ.getPoliticaDevoluciones();
    this.data_Empresa = this.genServ.getDataEmpresa();
    this.work_With_As = this.genServ.getworkWithA();
    this.info_Prov = this.genServ.getinfoProv();
    this.botonNovedades = this.genServ.getBotonNovedades();

    this.cdr.detectChanges();
  }

  get telefonoAtencionAlCliente() {
    return this.genServ.gettelefonoAtencionAlCliente()
  }

  get redes() {
    return this.genServ.returnRedes();
  }

  get menuWatermarkMensaje() {
    return this.genServ.getMenuWatermarkMensaje()
  }

  get logosrc() {
    return this.genServ.getLogo();
  }

  get nombreSitio() {
    return this.genServ.getNombreSitio();
  }

  goToInfo(label: string) {
    switch (label) {
      case 'modal-data-empresa':
        this.modal.open('modal-data-empresa');
        break;
      case 'modal-info-prov':
        this.modal.open('modal-info-prov');
        break;
      case 'modal-work-withAs':
        this.modal.open('modal-work-withAs');
        break;
      case 'modal-terminos-condiciones':
        this.modal.open('modal-terminos-condiciones');
        break;
      default:
        this.modal.open('modal-no-implemented');
        break;
    }
  }

  arrepentimiento() {
    this.modal.open('modal-arrepentimiento');
  }
}
